// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App'
import router from './router'
import remote from './remote'
import store from './store'
import VuejsDialog from 'vuejs-dialog'
import VueFormGenerator from 'vue-form-generator'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueJwtDecode from 'vue-jwt-decode'
import Tooltip from 'primevue/tooltip'
import fieldCheckboxObjectArray from './vfg-custom-fields/fieldCheckboxObjectArray.vue'
import fieldAddAVC from './vfg-custom-fields/fieldAddAVC.vue'
import fieldTimePicker from './vfg-custom-fields/fieldTimePicker.vue'
import fieldTimePickerSepStartTime from './vfg-custom-fields/fieldTimePickerSepStartTime.vue'
import fieldTimePickerEndTime from './vfg-custom-fields/fieldTimePickerEndTime.vue'
import fieldLoadingDate from './vfg-custom-fields/fieldLoadingDate.vue'
import fieldDatePicker from './vfg-custom-fields/fieldDatePicker.vue'
import fieldFormattedDatePicker from './vfg-custom-fields/fieldFormattedDatePicker.vue'
import fieldListBoxWithAddValues from './vfg-custom-fields/fieldListBoxWithAddValues.vue'
import fieldAddTrucks from './vfg-custom-fields/fieldAddTrucks.vue'
import VueTimepicker from 'vuejs-timepicker'
import VueHtmlToPaper from 'vue-html-to-paper'
import ToastService from 'primevue/toastservice'
import JsonEditor from 'vue-json-editor-block-view'
import Excel from 'vue-excel-export'
import { round2dec, space1k } from '@/filters/NumericFilters.js'
import { toJSON } from '@/filters/TextFilters.js'
import 'primeflex/primeflex.min.css'
import 'primevue/resources/themes/nova-light/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
Vue.component('fieldCheckboxObjectArray', fieldCheckboxObjectArray)
Vue.component('fieldAddAVC', fieldAddAVC)
Vue.component('fieldTimePicker', fieldTimePicker)
Vue.component('fieldDatePicker', fieldDatePicker)
Vue.component('fieldFormattedDatePicker', fieldFormattedDatePicker)
Vue.component('fieldTimePickerSepStartTime', fieldTimePickerSepStartTime)
Vue.component('fieldTimePickerEndTime', fieldTimePickerEndTime)
Vue.component('fieldLoadingDate', fieldLoadingDate)
Vue.component('fieldListBoxWithAddValues', fieldListBoxWithAddValues)
Vue.component('fieldAddTrucks', fieldAddTrucks)

Vue.filter('round2dec', round2dec)
Vue.filter('space1k', space1k)
Vue.filter('toJSON', toJSON)

Vue.prototype.$http = remote()

const htmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    './static/invoiceprint.css'
  ]
}

require('./assets/css/dialog.css')
require('./assets/css/tooltip.css')
require('./assets/css/style.css')

Vue.use(BootstrapVue)
Vue.use(VuejsDialog)
Vue.use(VueFormGenerator)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VueJwtDecode)
Vue.use(VueTimepicker)
Vue.use(ToastService)
Vue.use(VueHtmlToPaper, htmlToPaperOptions)
Vue.use(JsonEditor)
Vue.use(Excel)

Vue.directive('tooltip', Tooltip)

Vue.config.productionTip = false

export const bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js